import Link from 'next/link';
import { useRouter } from 'next/router';

import { Alert, CloseButton, Text, TextButton } from '@zillow/constellation-10';

import { ROUTES } from '../../constants/urls';

import type { IdentityVerificationContent } from './content';

type IdentityVerificationAlertProps = {
  content: IdentityVerificationContent;
  /** Renders a close button; omit to make the Alert non-dismissible. */
  onClose?: () => void;
  testId: string;
};

const IdentityVerificationAlert = ({ content, onClose, testId }: IdentityVerificationAlertProps) => {
  const router = useRouter();

  return (
    <Alert
      data-testid={testId}
      tone={content.tone}
      isOpen
      onClose={onClose}
      closeButton={onClose ? <CloseButton /> : null}
      actionButton={
        content.cta && (
          <TextButton asChild>
            {content.cta.href ? (
              <a href={content.cta.href}>{content.cta.label}</a>
            ) : (
              <Link href={{ pathname: ROUTES.VERIFY_IDENTITY, query: { returnTo: router.asPath } }}>
                {content.cta.label}
              </Link>
            )}
          </TextButton>
        )
      }
    >
      <Text textStyle="body-bold" css={{ display: 'block' }}>
        {content.header}
      </Text>
      {content.body}
    </Alert>
  );
};

export default IdentityVerificationAlert;
